import { render } from "./CommunityAdminBanner.vue?vue&type=template&id=fdd34942&scoped=true"
import script from "./CommunityAdminBanner.vue?vue&type=script&lang=js"
export * from "./CommunityAdminBanner.vue?vue&type=script&lang=js"

import "./CommunityAdminBanner.vue?vue&type=style&index=0&id=fdd34942&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdd34942"]])

export default __exports__